import React from "react";

import { Tooltip } from "@toddle-edu/ds-web";
import { WarningCircleOutlined } from "@toddle-edu/ds-icons";
import { getIsAdminByRole } from "lib/staffPermissionUtils";
import { SCORE } from "Constants/stringConstants";

import { canManageAssessmentCategories } from "Settings/modules/SettingsUtils";

const NoGradeCalculationMethodSelectedWarning = ({
  t,
  entityType,
  columnType,
  isCategoryScoreValuesEmpty,
}) => {
  const isAdmin = getIsAdminByRole();
  let tooltip;

  const label =
    columnType === "CATEGORY"
      ? t("academicSetup:category")
      : t("common:grading_period");

  if (isCategoryScoreValuesEmpty) {
    const isTeacherAllowedToEditCategories = canManageAssessmentCategories();

    if (isAdmin || isTeacherAllowedToEditCategories) {
      tooltip = t(
        "academicSetup:no_category_weights_and_teacher_has_permissions_error_tooltip_with_label",
        { label }
      );
    } else {
      tooltip = t(
        "academicSetup:no_category_weights_and_teacher_has_no_permissions_error_tooltip_with_label",
        { label }
      );
    }
  } else {
    if (isAdmin) {
      tooltip =
        entityType === SCORE
          ? t(
              "academicSetup:please_select_a_calculation_method_to_calculate_overall_score"
            )
          : t(
              "academicSetup:please_select_a_calculation_method_to_calculate_overall_grade"
            );
    } else {
      tooltip =
        entityType === SCORE
          ? t(
              "academicSetup:overall_score_will_be_automatically_calculated_for_label_once_calculation_method_is_defined",
              {
                label,
              }
            )
          : t(
              "academicSetup:overall_grade_will_be_automatically_calculated_for_label_once_calculation_method_is_defined",
              { label }
            );
    }
  }

  return (
    <Tooltip tooltip={tooltip}>
      <WarningCircleOutlined variant="warning" />
    </Tooltip>
  );
};

export default NoGradeCalculationMethodSelectedWarning;
